// Helper functions

export const money = (n) =>
  (Number(n) || 0).toLocaleString("es-ES", { style: "currency", currency: "EUR" });

export const formatDate = (d) => {
  if (!d) return "-";
  try {
    return new Date(d).toLocaleDateString("es-ES");
  } catch {
    return d;
  }
};

export const daysUntil = (d) => {
  if (!d) return null;
  return Math.floor((new Date(d) - new Date()) / 86400000);
};

export const estadoClass = (e) =>
  ({
    Pendiente: "badge-gray",
    "En curso": "badge-blue",
    Finalizado: "badge-green",
    Facturado: "badge-orange",
    Borrador: "badge-gray",
    Confirmada: "badge-blue",
    Facturada: "badge-orange",
    Cobrada: "badge-green",
  }[e] || "badge-gray");

export const clienteName = (state, id) =>
  (state.clientes.find((c) => c.id === id) || {}).nombre || "-";

export const proyectoName = (state, id) =>
  (state.proyectos.find((p) => p.id === id) || {}).nombre || "-";

export const subtotalArticulos = (o) =>
  (o.articulos || []).reduce((s, l) => s + (+l.cantidad || 0) * (+l.precio || 0), 0);

export const subtotalServicios = (o) =>
  (o.servicios || []).reduce((s, l) => s + (+l.cantidad || 0) * (+l.precio || 0), 0);

export const proyectoTotal = (p) => subtotalArticulos(p) + subtotalServicios(p);

export const ventaBase = (v) => {
  const a = (v.items || []).reduce((s, l) => s + (+l.cantidad || 0) * (+l.precio || 0), 0);
  const b = (v.serviciosItems || []).reduce((s, l) => s + (+l.cantidad || 0) * (+l.precio || 0), 0);
  return a + b;
};

export const ventaTotal = (v) => ventaBase(v) * (1 + (+v.iva || 0) / 100);

export const statusMedico = (p) => {
  const d = daysUntil(p.fechaReconocimientoMedico);
  if (d === null) return { txt: "—", cls: "badge-gray" };
  if (d < 0) return { txt: "Caducado", cls: "badge-red" };
  if (d <= 30) return { txt: `${d}d`, cls: "badge-orange" };
  return { txt: "Vigente", cls: "badge-green" };
};

export const statusPRL = (p) => {
  const d = daysUntil(p.fechaCaducidadPRL);
  if (d === null) return { txt: "—", cls: "badge-gray" };
  if (d < 0) return { txt: "Caducado", cls: "badge-red" };
  if (d <= 30) return { txt: `${d}d`, cls: "badge-orange" };
  return { txt: "Vigente", cls: "badge-green" };
};

// Build a Servicios display name from fields: {mes}_{incidencia} SEDE {sede}
// Only incidencia is required.
export const buildServicioNombre = ({ mes, incidencia, sede }) => {
  const m = (mes || "").trim();
  const inc = (incidencia || "").trim();
  const s = (sede || "").trim();
  if (!inc) return "";
  let out = "";
  if (m) out += `${m}_`;
  out += inc;
  if (s) out += ` SEDE ${s}`;
  return out;
};

// Search + sort helpers used by many pages
export const filterAndSort = (rows, search, sort, state) => {
  const q = (search || "").toLowerCase().trim();
  let r = q
    ? rows.filter((row) => JSON.stringify(row).toLowerCase().includes(q))
    : rows.slice();
  if (sort && sort.field) {
    const { field, dir } = sort;
    r.sort((a, b) => {
      let va = sortValue(a, field, state);
      let vb = sortValue(b, field, state);
      if (va == null) va = "";
      if (vb == null) vb = "";
      if (typeof va === "number" && typeof vb === "number") return (va - vb) * dir;
      return String(va).localeCompare(String(vb), "es", { numeric: true, sensitivity: "base" }) * dir;
    });
  }
  return r;
};

const sortValue = (row, f, state) => {
  if (!state) return row[f];
  if (f === "cliente") return clienteName(state, row.clienteId);
  if (f === "proyecto") return proyectoName(state, row.proyectoId);
  if (f === "total" && row.articulos && row.servicios) return proyectoTotal(row);
  if (f === "nArt") return (row.articulos || []).length;
  if (f === "nServ") return (row.servicios || []).length;
  if (f === "nPers") return (row.personalIds || []).length;
  if (f === "nLineas") return (row.items || []).length + (row.serviciosItems || []).length;
  if (f === "statusMedico") {
    const d = daysUntil(row.fechaReconocimientoMedico);
    return d == null ? 9e9 : d;
  }
  if (f === "statusPRL") {
    const d = daysUntil(row.fechaCaducidadPRL);
    return d == null ? 9e9 : d;
  }
  return row[f];
};

export const sortArr = (sort, field) => {
  if (sort.field !== field) return "↕";
  return sort.dir === 1 ? "▲" : "▼";
};
